export const locale = {
    lang: 'fr',
    data: {
        PROJECTS_DIALOGS_NEW_DIALOG_ADD_PARAGRAPHE: 'Ajouter un paragraphe',
        PROJECTS_DIALOGS_NEW_DIALOG_TITLE: 'Titre',
        PROJECTS_DIALOGS_NEW_DIALOG_SAVE: 'Enregistrer',
        PROJECTS_DIALOGS_NEW_DIALOG_CANCEL: 'Annuler',
    }
};
